// extracted by mini-css-extract-plugin
export var typingIndicator = "_kl-0";